import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";

@Component({
  selector: "app-tasks-table",
  templateUrl: "./tasks-table.component.html",
  styleUrls: ["./tasks-table.component.css"],
})
export class TasksTableComponent implements OnInit {
  @Input() headers: string[] = [];
  @Input() data: any[][] = [];
  @Input() itemsPerPage: number = 5;
  @Output() edit = new EventEmitter<any>();
  @Output() delete = new EventEmitter<any>();

  constructor() {}

  currentPage: number = 1; // Página atual
  paginatedData: any[][] = []; // Dados paginados
  totalPages: number = 1; // Total de páginas

  searchQuery: string = "";
  selectedStatus: string = "";
  selectedPerson: string = "";

  filteredData: any[][] = [];

  ngOnInit(): void {
    this.filteredData = this.data;
    this.calculatePagination();
  }

  calculatePagination() {
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    const endIndex = startIndex + this.itemsPerPage;
    this.paginatedData = this.filteredData.slice(startIndex, endIndex);
    this.totalPages = Math.ceil(this.filteredData.length / this.itemsPerPage);
  }

  changePage(page: number) {
    if (page >= 1 && page <= this.totalPages) {
      this.currentPage = page;
      this.calculatePagination();
    }
  }

  search() {
    this.filterData();
  }

  filterByStatus() {
    this.filterData();
  }

  filterByPerson() {
    this.filterData();
  }

  filterData() {
    const query = this.searchQuery.toLowerCase();
    this.filteredData = this.data.filter((row) => {
      const matchesSearch = row.some((col) => col.toString().toLowerCase().includes(query));
      const matchesStatus = this.selectedStatus ? row.includes(this.selectedStatus) : true;
      const matchesPerson = this.selectedPerson ? row.includes(this.selectedPerson) : true;
      return matchesSearch && matchesStatus && matchesPerson;
    });

    this.currentPage = 1;
    this.calculatePagination();
  }

  onEdit(row: any) {
    this.edit.emit(row);
  }

  onDelete(row: any) {
    this.delete.emit(row);
  }

  getUniqueStatus(): string[] {
    const statusIndex = this.headers.indexOf("Status");
    if (statusIndex === -1) return [];

    const status = this.data.map((row) => row[statusIndex]);
    return [...new Set(status)];
  }

  getUniquePerson(): string[] {
    const peopleIndex = this.headers.indexOf("Usuário");
    if (peopleIndex === -1) return [];

    const people = this.data.map((row) => row[peopleIndex]);
    return [...new Set(people)];
  }
}
